module.exports = __webpack_public_path__ + "media/games-11.6be60589.mp4";